import { Logout } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

export const LogOut = ({ username, handleLogout }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      position="absolute"
      bottom="15px"
      zIndex="100000"
      px={2}
      width="100%"
      alignItems="center"
    >
      <Box display="flex">
        <Box
          width="24px"
          mr={1}
          height="24px"
          backgroundColor="white"
          color="black"
          borderRadius="12px"
          alignItems="center"
        >
          <Typography
            textTransform="uppercase"
            color="black"
            textAlign="center"
            fontSize="12px"
            paddingTop="3px"
          >
            {username[0]}
          </Typography>
        </Box>
        <Typography color="white" fontFamily="Mulish" fontSize="14px">
          {username}
        </Typography>
      </Box>

      <Logout onClick={handleLogout} style={{ color: 'white', cursor: 'pointer' }} />
    </Box>
  );
};

LogOut.propTypes = {
  username: PropTypes.string.isRequired,
  handleLogout: PropTypes.func.isRequired
};
